import React, { useState } from "react";
import AuctionImageUpload from "../../components/imageUpload/auctionImageUpload";
import axios from "axios";
import { API_BASE_URL, API_ROUTES } from "../../config";
import Swal from "sweetalert2";

export default function ImageuploadContainer({
	auth_token,
	product_id,
	auction_id,
	auction_name,
	brand,
	model,
}) {
	const [files, setFiles] = useState([]);
	const [previewImages, setPreviewImages] = useState([]);
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState({});

	const handleFileChange = (e) => {
		const selectedFiles = e.target.files;

		// Validate file type and limit the number of uploads
		const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
		const maxUploads = 10;
        if(selectedFiles.length > maxUploads){
            Swal.fire({
                icon: "Info",
                confirmButtonColor: "#652078",
                text: "Invalid file type or exceeding upload limit",
            }).then((res) => {
                if (res) {
                    setFiles([]);
                    setPreviewImages([]);
                }
            });
        }

		for (let i = 0; i < selectedFiles.length; i++) {
			const file = selectedFiles[i];

			if (allowedTypes.includes(file.type) && files.length < maxUploads) {
				// Read the file and create a preview
				const reader = new FileReader();

				reader.onload = (event) => {
					setFiles((prevFiles) => [...prevFiles, file]);
					setPreviewImages((prevPreviews) => [
						...prevPreviews,
						event.target.result,
					]);
				};

				reader.readAsDataURL(file);
			} else {
				// Handle invalid file type or exceeding upload limit
				console.error('Invalid file type or exceeding upload limit');
			}
		}
	};

	const handleUpload = async () => {
        if(files.length === 0 || files.length > 10){
            Swal.fire({
                icon: "Info",
                confirmButtonColor: "#652078",
                text: "Invalid file type or exceeding upload limit",
            }).then((res) => {
                if (res) {
                    setFiles([]);
                    setPreviewImages([]);
                }
            });
            return false;
        }
        //console.log("hello")
        setLoading(true);
		// Create JSON object with filename and base64 data
		const jsonData = files.map((file) => ({
			name: file.name,
			data: "data/png," + previewImages[files.indexOf(file)].split(",")[1],
		}));

		//files.map((file) =>  console.log(previewImages[files.indexOf(file)].split(",")[1],"indexof",files.indexOf(file),"files",files,"file",file,"previewImages",previewImages));

		const data = {
			files: jsonData,
			product_id: product_id,
		};

		// Send jsonData to the backend
		try {
			const res = await axios({
				method: "post",
				headers: {
					Authorization: `Bearer ${auth_token}`,
				},
				url: `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_IMAGE}`,
				data: data,
			});
            console.log(res)
			setLoading(false);
			Swal.fire({
				icon: "success",
				confirmButtonColor: "#652078",
				text: "Uploaded successfully",
			}).then((res) => {
				if (res) {
					window.location.href = `https://app.appsmith.com/app/handle-file-upload/tractor-list-657c14b57ca71f6eecc13f8e?auction_id=${auction_id}&auction_name=${auction_name}`;
				}
			});
		} catch (e) {
			setLoading(false);
			Swal.fire({
				icon: "error",
				confirmButtonColor: "#652078",
				text: "Something went wrong ...",
			}).then((res) => {
				if (res) {
				}
			});
		}
		//console.log(jsonData);
	};

	const cancelHandler = () => {
		window.location.href = `https://app.appsmith.com/app/handle-file-upload/tractor-list-657c14b57ca71f6eecc13f8e?auction_id=${auction_id}&auction_name=${auction_name}`;
	};

	return (
		<AuctionImageUpload
			handleFileChange={handleFileChange}
			handleUpload={handleUpload}
			cancelHandler={cancelHandler}
			files={files}
			previewImages={previewImages}
			loading={loading}
			brand={brand}
			model={model}
			multipleImageStatus={true}
		/>
	);
}
